import { Box, useTheme } from "@mui/material";
import { BasicSwitch, TitleSubTitle } from "@platformx/utilities";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "../Seo/Seo.styles";

const Analytics = ({ state, setState }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const [analyticsState, setAnalyticsState] = useState({
    analytics: true,
    impression: true,
    insight: false,
  });
  const handleAnalyticsChange = () => {
    setState({
      ...state,
      CommonFields: {
        ...state.CommonFields,
        analytics_enable: !state?.CommonFields?.analytics_enable,
      },
    });
  };

  return (
    <>
      <Box className={classes.container}>
        <Box className={classes.width40}>
          <TitleSubTitle
            title={t("analytics")}
            subTitle={""}
            titleVariant='h6medium'
            subTitleVariant='p4regular'
          />
        </Box>
        <Box className={classes.width60}>
          <BasicSwitch
            onChange={
              handleAnalyticsChange
              // setAnalyticsState({
              //   ...analyticsState,
              //   analytics: !analyticsState.analytics,
              // })
            }
            checked={state?.CommonFields?.analytics_enable}
            // disabled={isDisable}
            color={theme.palette.customColor.PRIMARY}
          />
        </Box>
      </Box>
      <Box className={classes.container}>
        <Box className={classes.width40}>
          <TitleSubTitle
            title={t("impression")}
            subTitle={""}
            titleVariant='h6medium'
            subTitleVariant='p4regular'
          />
        </Box>
        <Box className={classes.width60}>
          <BasicSwitch
            onChange={() =>
              setAnalyticsState({
                ...analyticsState,
                impression: !analyticsState.impression,
              })
            }
            checked={analyticsState.impression}
            // disabled={isDisable}
            color={theme.palette.customColor.PRIMARY}
          />
        </Box>
      </Box>
      {/* <Box className={classes.container}>
        <Box className={classes.width40}>
          <TitleSubTitle
            title={t('content_insight')}
            subTitle={t('subheading_description')}
            titleVarient='h6medium'
            subTitleVarient='h7regular'
          />
        </Box>
        <Box className={classes.width60}>
          <BasicSwitch
            onChange={() =>
              setAnalyticsState({
                ...analyticsState,
                insight: !analyticsState.insight,
              })
            }
            checked={analyticsState.insight}
            // disabled={isDisable}
            color={theme.palette.customColor.PRIMARY}
          />
        </Box>
      </Box> */}
    </>
  );
};

export default Analytics;
